import PublicIp from './PublicIp'

export default PublicIp
